import { Box, FormControlLabel, Paper, Switch, Typography } from '@mui/material';
import { t } from 'i18next';
import { UrlHelper } from '../../../common/utils/UrlHelper';
import { Interpolation } from '../../../config/i18n/components/Interpolation';
import { PATHS } from '../../../routing/routes';
import { Project } from '../models/Project';
import { FilteredViewToggler as FilteredViewTogglerSkeleton } from './skeletons/FilteredViewToggler';

type Props = {
  active: boolean;
  onToggle: () => void;
  project: Project | null;
  loading: boolean;
};

export const FilteredViewToggler = ({ active, onToggle, project, loading }: Props) => {
  if (loading) {
    return <FilteredViewTogglerSkeleton />;
  }
  if (project === null) {
    return null;
  }

  const newExceptionUrl = UrlHelper.generatePath(PATHS.PROJECT_FILTERS, { projectId: project.getId().toString() });
  const newExceptionAriaLabel = t('a11y.project.dashboard.createNewExceptionLink');

  return (
    <Paper sx={{ px: 2, py: 1 }}>
      <FormControlLabel
        disableTypography
        control={<Switch checked={active} onChange={onToggle} />}
        label={
          <Box>
            <Typography variant="subtitle2" component="p" sx={{ fontWeight: 700 }}>
              {t('filterExceptionsFromThisViewOfProject', { projectName: project.getName() })}
            </Typography>
            <Interpolation
              i18nKey="lookingToCreateNewAException"
              items={[{ name: 'anchor', href: newExceptionUrl, 'aria-label': newExceptionAriaLabel }]}
              variant="subtitle2"
              sx={{ color: 'text.secondary' }}
            />
          </Box>
        }
      />
    </Paper>
  );
};
